export const FETCH_ASSIGNMENTS_STARTED = 'FETCH_ASSIGNMENTS_STARTED';
export const FETCH_ASSIGNMENTS_SUCCESS = 'FETCH_ASSIGNMENTS_SUCCESS';
export const FETCH_ASSIGNMENTS_FAILED = 'FETCH_ASSIGNMENTS_FAILED';

export const FETCH_ASSIGNMENT_STARTED = 'FETCH_ASSIGNMENT_STARTED';
export const FETCH_ASSIGNMENT_SUCCESS = 'FETCH_ASSIGNMENT_SUCCESS';
export const FETCH_ASSIGNMENT_FAILED = 'FETCH_ASSIGNMENT_FAILED';

export const FETCH_GRADES_STARTED = 'FETCH_GRADES_STARTED';
export const FETCH_GRADES_SUCCESS = 'FETCH_GRADES_SUCCESS';
export const FETCH_GRADES_FAILED = 'FETCH_GRADES_FAILED';

export const FETCH_STUDENT_GRADES_STARTED = 'FETCH_STUDENT_GRADES_STARTED';
export const FETCH_STUDENT_GRADES_SUCCESS = 'FETCH_STUDENT_GRADES_SUCCESS';
export const FETCH_STUDENT_GRADES_FAILED = 'FETCH_STUDENT_GRADES_FAILED';

export const UPDATE_ASSIGNMENT_GRADES_STARTED =
  'UPDATE_ASSIGNMENT_GRADES_STARTED';
export const UPDATE_ASSIGNMENT_GRADES_SUCCESS =
  'UPDATE_ASSIGNMENT_GRADES_SUCCESS';
export const UPDATE_ASSIGNMENT_GRADES_FAILED =
  'UPDATE_ASSIGNMENT_GRADES_FAILED';

export const CREATE_ASSIGNMENT_STARTED = 'CREATE_ASSIGNMENT_STARTED';
export const CREATE_ASSIGNMENT_SUCCESS = 'CREATE_ASSIGNMENT_SUCCESS';
export const CREATE_ASSIGNMENT_FAILED = 'CREATE_ASSIGNMENT_FAILED';

export const RELEASE_GRADES_STARTED = 'RELEASE_GRADES_STARTED';
export const RELEASE_GRADES_SUCCESS = 'RELEASE_GRADES_SUCCESS';
export const RELEASE_GRADES_FAILED = 'RELEASE_GRADES_FAILED';

export const GRADE_MANUAL_ASSIGNMENT_STARTED =
  'GRADE_MANUAL_ASSIGNMENT_STARTED';
export const GRADE_MANUAL_ASSIGNMENT_SUCCESS =
  'GRADE_MANUAL_ASSIGNMENT_SUCCESS';
export const GRADE_MANUAL_ASSIGNMENT_FAILED = 'GRADE_MANUAL_ASSIGNMENT_FAILED';

export const UPDATE_ASSIGNMENT_STARTED = 'UPDATE_ASSIGNMENT_STARTED';
export const UPDATE_ASSIGNMENT_SUCCESS = 'UPDATE_ASSIGNMENT_SUCCESS';
export const UPDATE_ASSIGNMENT_FAILED = 'UPDATE_ASSIGNMENT_FAILED';

export const DELETE_ASSIGNMENT_SUCCESS = 'DELETE_ASSIGNMENT_SUCCESS';
export const DELETE_ASSIGNMENT_FAILED = 'DELETE_ASSIGNMENT_FAILED';

export const IMPORT_MANUAL_ASSIGNMENT_GRADES_STARTED =
  'IMPORT_MANUAL_ASSIGNMENT_GRADES_STARTED';
export const IMPORT_MANUAL_ASSIGNMENT_GRADES_SUCCESS =
  'IMPORT_MANUAL_ASSIGNMENT_GRADES_SUCCESS';
export const IMPORT_MANUAL_ASSIGNMENT_GRADES_FAILED =
  'IMPORT_MANUAL_ASSIGNMENT_GRADES_FAILED';
